import { PageFilter } from "../../shared/components/filter";
import { PageHeading } from "../../shared/components/heading";
import request from "../../shared/utils/request";
import { useEffect, useState } from "react";
import "./style.css";
import { cropSentence } from "../../shared/utils/cropSentense";
import { Link } from "react-router-dom";
import { Loader } from "../../shared/components/loader";
import { Slide } from "react-awesome-reveal";
import PreviewImage from "../../assets/img/preview.png";

export const MyLibrary = () => {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [cardDatas, setCardDatas] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1);

  useEffect(() => {
    getDatas();
  }, [search, page]);

  const getDatas = async () => {
    try {
      setLoading(true);
      const response = await request.get("student/getReadTogether", {
        params: {
          page: page,
          size: 12,
          filter: search,
          status: "Active",
        },
      });
      if (response?.data?.status) {
        setCardDatas(response?.data?.readTogether);
        setTotalRows(response?.data?.totalRows);
      }
    } catch (error) {
      console.error("Error fetching  data:", error);
    } finally {
      setLoading(false); // Step 3: Set loading to false after the request is completed
    }
  };

  return (
    <section id="services" className="services section my-library">
      <div className="container section-title" data-aos="fade-up">
        <Slide direction="down">
          <PageHeading heading={"My Library"} />
        </Slide>
      </div>
      <Loader isLoading={loading} />
      <div className="container ">
        <PageFilter
          onChange={(event) => {
            setSearch(event.target.value);
          }}
          totalRows={totalRows}
          page={page}
          handlePageChange={(page) => setPage(page)}
        />

        <div className="row gy-4 library-row">
          <>
            {cardDatas?.map((cardData, rowIndex) => (
              <Slide
                direction="up"
                cascade
                damping={0.2}
                triggerOnce
                className="col-lg-4 col-md-6"
                key={rowIndex}
              >
                <Link to={`/student/my-library/${cardData?.id}`}>
                  <div className="card-wrapper">
                    <div className="custom-card">
                      <div className="row g-0">
                        {/* Thumbnail column */}
                        <div className="col-md-4 col-sm-4 col-3">
                          <div className=" d-flex align-items-center justify-content-center">
                            <img
                              src={
                                cardData?.thumbnail_link
                                  ? cardData?.thumbnail_link_path
                                  : PreviewImage
                              }
                              alt="English studio"
                              className="thumbnail-img"
                            />
                          </div>
                        </div>

                        {/* Description column */}
                        <div className="col-md-8 col-sm-8 col-9">
                          <div className="card-body">
                            <span className="badge badge-custom text-white">
                              Click to Read
                            </span>
                            <h5 className="card-title crop-libray-heading">
                              {cropSentence(cardData?.title, 3)}
                            </h5>
                            <p
                              className="card-text mt-2 crop-libray-sentenses"
                              dangerouslySetInnerHTML={{
                                __html: cardData?.short_description,
                              }}
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </Slide>
            ))}
          </>
        </div>
      </div>
    </section>
  );
};
